import React from 'react';

import Feed from '../../Feed';

const SavedEventsTab = ({ savedEvents, events, location }) => {
  const filteredEvents = savedEvents && events && events.filter(function(event){
    return this.indexOf(event.id) >= 0
  }, savedEvents);

  const getCaption = () => {
    const reg = /[_/]/ig;
    return this.props.location.pathname.replace(reg, " ")
  }

  return (
    <div className="tab-content">
      {
        filteredEvents && (
          <Feed
            list={filteredEvents}
            location ={location}
            getCaption={getCaption}
            renderType={"events"}
            eventType={"all"}
          />
        )
      }
    </div>
  );
}

export default SavedEventsTab;


// WEBPACK FOOTER //
// ./src/pages/MyProfile/SavedEventsTab/index.js